<template>
    <div class="courses_home">

        <HeadImg :msg="titleName" :url="imgCourses"></HeadImg>

        <div class="shilineBox">
            <div class="rLine"></div>
            <div class="cLine"></div>
        </div>

        <div class="courses2">
            <div class="c2_cont">
                <div class="c2_item cn">
                    <p class="c2_p1">VIP院校计划</p>
                    <p class="c2_p2">适合人群：</p>
                    <p class="c2_p3">申请艺术设计院校本科、研究生的学生</p>
                    <div class="c2_img_box">
                        <img src="../img/艺术课程/Rectangle 155.jpg" alt="" class="c2_img">
                        <img src="../img/艺术课程/Group 339.png" alt="" class="c2_icon">
                        <div class="c2_hid_box">
                            <ul>
                                <li><span></span>定制化全套作品集课程</li>
                                <li><span></span>海外教授多V1辅导</li>
                                <li><span></span>欧美权威专业TOP3、TOP5、TOP8名校OFFER</li>
                                <li><span></span>梦校直通车</li>
                            </ul>
                            <div class="kefu_btn">
                                <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })"><img
                                        src="../img/homepage-折叠部分切图/Group 189.png" alt=""></a>
                                <a href="/PortfolioInfo/vip.html"><img src="../img/homepage-折叠部分切图/Group 194.png"
                                        alt=""></a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="c2_item cn">
                    <p class="c2_p1">专业作品集辅导</p>
                    <p class="c2_p2">适合人群：</p>
                    <p class="c2_p3">已具备基础课能力的学生，计划申请艺术设计院校本科、研究生</p>
                    <div class="c2_img_box">
                        <img src="../img/艺术课程/Rectangle 156.jpg" alt="" class="c2_img">
                        <img src="../img/艺术课程/Group 339.png" alt="" class="c2_icon">
                        <div class="c2_hid_box">
                            <ul>
                                <li><span></span>多名艺术导师量身制定作品集产出</li>
                                <li><span></span>海外高等院校教学模式</li>
                                <li><span></span>四级教学法+五维审核体系</li>
                                <li><span></span>多元化竞赛资源</li>
                            </ul>
                            <div class="kefu_btn">
                                <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })"><img
                                        src="../img/homepage-折叠部分切图/Group 189.png" alt=""></a>
                                <a href="/PortfolioInfo/professional_portfolio.html"><img
                                        src="../img/homepage-折叠部分切图/Group 194.png" alt=""></a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="c2_item c2_item3 cn">
                    <p class="c2_p1">海外游学与夏校项目</p>
                    <p class="c2_p2">适合人群：</p>
                    <p class="c2_p3">15周岁以上高中或大学生</p>
                    <div class="c2_img_box">
                        <img src="../img/艺术课程/Rectangle 157.jpg" alt="" class="c2_img">
                        <img src="../img/艺术课程/Group 339.png" alt="" class="c2_icon">
                        <div class="c2_hid_box">
                            <ul>
                                <li><span></span>与海外导师合作，独家定制课程</li>
                                <li><span></span>沉浸式体验，探索灵感来源</li>

                                <li><span></span>实际前往院校，深入名校课堂</li>
                            </ul>
                            <div class="kefu_btn">
                                <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })"><img
                                        src="../img/homepage-折叠部分切图/Group 189.png" alt=""></a>
                                <a href="/promoting.html"><img src="../img/homepage-折叠部分切图/Group 194.png" alt=""></a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="c2_item cn">
                    <p class="c2_p1">BTEC艺术设计预科</p>
                    <p class="c2_p2">适合人群：</p>
                    <p class="c2_p3">16周岁及以上，高中毕业或在读学生</p>
                    <div class="c2_img_box">
                        <img src="../img/艺术课程/Rectangle 158.jpg" alt="" class="c2_img">
                        <img src="../img/艺术课程/Group 339.png" alt="" class="c2_icon">
                        <div class="c2_hid_box">
                            <ul>
                                <li><span></span>官方认证BTEC办学&考试中心</li>
                                <li><span></span>本科直录核心课程</li>
                                <li><span></span>提前适应国外艺术教育模式</li>
                                <li><span></span>证书全球认可、学分终身有效</li>
                            </ul>
                            <div class="kefu_btn">
                                <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })"><img
                                        src="../img/homepage-折叠部分切图/Group 189.png" alt=""></a>
                                <a href="/PortfolioInfo/art_management.html"><img src="../img/homepage-折叠部分切图/Group 194.png"
                                        alt=""></a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="c2_item cn">
                    <p class="c2_p1">A-Level课程</p>
                    <p class="c2_p2">适合人群：</p>
                    <p class="c2_p3">16-19 周岁（ 初中毕业 / 高中在读 ）</p>
                    <div class="c2_img_box">
                        <img src="../img/艺术课程/Rectangle 159.jpg" alt="" class="c2_img">
                        <img src="../img/艺术课程/Group 339.png" alt="" class="c2_icon">
                        <div class="c2_hid_box">
                            <ul>
                                <li><span></span>官方认证的A Level办学&考试中心</li>
                                <li><span></span>为英联邦艺术留学申请定制</li>
                                <li><span></span>灵活的选课机制助学生扬长避短</li>
                                <li><span></span>开设多门艺术学科，多维度拓展艺术领域知识</li>
                            </ul>
                            <div class="kefu_btn">
                                <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })"><img
                                        src="../img/homepage-折叠部分切图/Group 189.png" alt=""></a>
                                <a href="/PortfolioInfo/grand_master.html"><img src="../img/homepage-折叠部分切图/Group 194.png"
                                        alt=""></a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="c2_item   cn">
                    <p class="c2_p1">GA&GD创意基础课</p>
                    <p class="c2_p2">适合人群：</p>
                    <p class="c2_p3">12-16周岁</p>
                    <div class="c2_img_box">
                        <img src="../img/艺术课程/Rectangle 160.jpg" alt="" class="c2_img">
                        <img src="../img/艺术课程/Group 339.png" alt="" class="c2_icon">
                        <div class="c2_hid_box">
                            <ul>
                                <li><span></span>艺术设计启蒙课程</li>
                                <li><span></span>启发并引导自主的艺术创作</li>
                                <li><span></span>系统地培养艺术思维</li>
                                <li><span></span>提升艺术审美与创造力</li>
                            </ul>
                            <div class="kefu_btn">
                                <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })"><img
                                        src="../img/homepage-折叠部分切图/Group 189.png" alt=""></a>
                                <a href="/PortfolioInfo/foundation.html"><img src="../img/homepage-折叠部分切图/Group 194.png"
                                        alt=""></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="c2_item c2_item4 cn">
                    <p class="c2_p1">AP课程</p>
                    <p class="c2_p2">适合人群：</p>
                    <p class="c2_p3">申请艺术院校的高中生</p>
                    <div class="c2_img_box">
                        <img src="../img/艺术课程/Rectangle 161.jpg" alt="" class="c2_img">
                        <img src="../img/艺术课程/Group 339.png" alt="" class="c2_icon">
                        <div class="c2_hid_box">
                            <ul>
                                <li><span></span>助力美本直录</li>
                                <li><span></span>成绩可抵扣本科学分</li>
                                <li><span></span>官方审核评估机制</li>
                                <li><span></span>AP成绩与作品集双重把控</li>
                            </ul>
                            <div class="kefu_btn">
                                <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })"><img
                                        src="../img/homepage-折叠部分切图/Group 189.png" alt=""></a>
                                <a href="/PortfolioInfo/aesthetics_promoting.html"><img
                                        src="../img/homepage-折叠部分切图/Group 194.png" alt=""></a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="c2_item cn">
                    <p class="c2_p1">RoSSo College</p>
                    <p class="c2_p2">适合人群：</p>
                    <p class="c2_p3">申请艺术院校的高中生</p>
                    <div class="c2_img_box">
                        <img src="../img/艺术课程/Rectangle 162.jpg" alt="" class="c2_img">
                        <img src="../img/艺术课程/Group 339.png" alt="" class="c2_icon">
                        <div class="c2_hid_box">
                            <ul>
                                <li><span></span>全面发展，全科育人</li>
                                <li><span></span>小班教学，因材施教</li>
                                <li><span></span>在校即可完成作品集</li>
                                <li><span></span>官方合作申请通道</li>
                            </ul>
                            <div class="kefu_btn">
                                <a href="javascript:void(0)" onclick="_MEIQIA('showPanel',{ groupToken: 'c88f871be5ec47bd52d093a69fccf897' })"><img
                                        src="../img/homepage-折叠部分切图/Group 189.png" alt=""></a>
                                <a href="/PortfolioInfo/RossoCollege.html"><img src="../img/homepage-折叠部分切图/Group 194.png"
                                        alt=""></a>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="c2_item cn" style="background: none;"></div>

            </div>
        </div>


        <div class="courses3">
            <div class="section_title">
                <p class="section_cn">作品集辅导流程</p>
                <p class="section_en">PORTFOLIO PROCESS</p>
            </div>
            <div class="cour3_cont">
                <div class="cour3_item">
                    <img src="../img/艺术课程/Group 276.png" alt="">
                    <div class="c3_textbox">
                        <p class="cn">初期</p>
                        <p class="en">FIRSTSTEP</p>
                    </div>
                    <div class="dot_boss">
                        <div class="dot_box">
                            <div class="dot"></div><span>海归导师评估学生能力专业</span>
                        </div>
                        <div class="dot_box">
                            <div class="dot"></div><span>专业团队提供培训方案</span>
                        </div>
                        <div class="dot_box">
                            <div class="dot"></div><span>艺术教研团队审核方案</span>
                        </div>
                        <div class="dot_box">
                            <div class="dot"></div><span>作品集培训方案执行</span>
                        </div>

                    </div>
                </div>

                <div class="cour3_item">
                    <img src="../img/艺术课程/Group 277.png" alt="">
                    <div class="c3_textbox">
                        <p class="cn">中期</p>
                        <p class="en">SECONDSTEP</p>
                    </div>
                    <div class="dot_boss">
                        <div class="dot_box">
                            <div class="dot"></div><span>艺术基础课培训</span>
                        </div>
                        <div class="dot_box">
                            <div class="dot"></div><span>艺术专业课提升</span>
                        </div>
                        <div class="dot_box">
                            <div class="dot"></div><span>作品集1V1辅导</span>
                        </div>
                        <div class="dot_box">
                            <div class="dot"></div><span>跨学科思维植入</span>
                        </div>

                    </div>
                </div>

                <div class="cour3_item">
                    <img src="../img/艺术课程/Group 278.png" alt="">
                    <div class="c3_textbox">
                        <p class="cn">后期</p>
                        <p class="en">LASTSTEP</p>
                    </div>
                    <div class="dot_boss">
                        <div class="dot_box">
                            <div class="dot"></div><span>教研组作品集审核</span>
                        </div>
                        <div class="dot_box">
                            <div class="dot"></div><span>作品集优化提升</span>
                        </div>
                        <div class="dot_box">
                            <div class="dot"></div><span>招生官作品集审核</span>
                        </div>
                        <div class="dot_box">
                            <div class="dot"></div><span>作品集完成</span>
                        </div>

                    </div>
                </div>

            </div>
        </div>


        <div class="courses4">
            <div class="section_title">
                <p class="section_cn">RoSSo独特四步教学法</p>
                <p class="section_en">ROSSO METHODS</p>
            </div>

            <div class="c4_cont">
                <div class="c4_item">
                    <div class="c4_top">
                        <p>1</p>
                        <h2>艺术启发</h2>
                        <h2>基础先修课程</h2>
                    </div>
                    <div class="c41_bottom c4_bottom">
                        <p class="en">LEVEL 1：</p>
                        <p class="en">Universal</p>
                        <p class="en">Cornerstones</p>
                        <p class="en">of Art</p>
                    </div>
                </div>
                <div class="c4_item">
                    <div class="c4_top">
                        <p>2</p>
                        <h2>艺术探索</h2>
                        <h2>理论实践课程</h2>
                    </div>
                    <div class="c42_bottom c4_bottom">
                        <p class="en">LEVEL 2：</p>
                        <p class="en">Research and </p>
                        <p class="en">Technique</p>
                        <p class="en">Exploration</p>
                    </div>
                </div>
                <div class="c4_item">
                    <div class="c4_top">
                        <p>3</p>
                        <h2>艺术设计</h2>
                        <h2>项目核心课程</h2>
                    </div>
                    <div class="c43_bottom c4_bottom">
                        <p class="en">LEVEL3：</p>
                        <p class="en">Art and Design</p>
                        <p class="en">Project</p>
                        <p class="en">Establishment</p>
                    </div>
                </div>
                <div class="c4_item">
                    <div class="c4_top">
                        <p>4</p>
                        <h2>艺术设计</h2>
                        <h2>项目进阶课程</h2>
                    </div>
                    <div class="c44_bottom c4_bottom">
                        <p class="en">LEVEL 4：</p>
                        <p class="en">Art and Design</p>
                        <p class="en">Project</p>
                        <p class="en">Specialization</p>
                    </div>
                </div>

            </div>
        </div>


        <div class="shilineBox shilineBoxLeft">
            <div class="rLine"></div>
            <div class="cLine"></div>
        </div>

        <div class="courses5">
            <div class="section_title">
                <p class="section_cn">多重五维RoSSo审核体系</p>
                <p class="section_en">COMPREHENSIVE AUDIT SYSTEM</p>
            </div>
            <div class="c5_cont">
                <div class="c5_line1">
                    <div class="c5_item" @mouseenter="c5animate(0)" @mouseleave="c5animateBack(0)">
                        <div class="c5_show">
                            <p class="cn">1.专业审核 （初级考核）</p>
                            <img src="../img/艺术课程/Group 303.png" alt="" class="c5_show_img">
                        </div>
                        <div class="c5_hid">
                            主线导师指导下定制教学大纲。专业导师对每次课程作业和项目产出进行审核与把控
                        </div>
                    </div>
                    <div class="c5_item" @mouseenter="c5animate(1)" @mouseleave="c5animateBack(1)">
                        <div class="c5_show">
                            <p class="cn">2. 阶段性考核（期中考核）</p>
                            <img src="../img/艺术课程/Group 303.png" alt="" class="c5_show_img">
                        </div>
                        <div class="c5_hid">
                            还原海外授课模式，每2/3个月进行阶段性critique审核，训练学生面试的逻辑感和表达能力；
                        </div>
                    </div>
                    <div></div>
                </div>
                <div class="c5_line2">
                    <div class="c5_item" @mouseenter="c5animate(2)" @mouseleave="c5animateBack(2)">
                        <div class="c5_show">
                            <p class="cn">3. 进阶项目提升</p>
                            <img src="../img/艺术课程/Group 303.png" alt="" class="c5_show_img">
                        </div>
                        <div class="c5_hid">
                            所属科系主管组织多名导师对学员产出进度和发展方向进行科系内审与评估，助力学员在后半程进阶提升；
                        </div>
                    </div>
                    <div class="c5_item" @mouseenter="c5animate(3)" @mouseleave="c5animateBack(3)">
                        <div class="c5_show">
                            <p class="cn">4. 教研终审</p>
                            <img src="../img/艺术课程/Group 303.png" alt="" class="c5_show_img">
                        </div>
                        <div class="c5_hid">
                            全国教研组对学员的每个项目进行审核，采用海外名校的考核维度与RoSSo多年教学经验相结合，提供更专业和客观的建议，严格把控作品质量；
                        </div>
                    </div>
                    <div class="c5_item" @mouseenter="c5animate(4)" @mouseleave="c5animateBack(4)">
                        <div class="c5_show">
                            <p class="cn">5. 名校教授审核</p>
                            <img src="../img/艺术课程/Group 303.png" alt="" class="c5_show_img">
                        </div>
                        <div class="c5_hid">
                            海外教授以真实的海外名校教学和审核体制为蓝本，对学员作品进行全面审核与评估，从经验和权威性等方面助力学员提升申请成功率。
                        </div>
                    </div>
                    <div></div>
                </div>
            </div>
        </div>

        <div class="courses6">
            <div class="section_title">
                <p class="section_cn">RoSSo作品集课程优势</p>
                <p class="section_en">WHY CHOOSE ROSSO</p>
            </div>
            <div class="c6_cont">
                <img src="../img/艺术课程/Group 316.png" alt="" class="c6_cont_left  wow  bounceInLeft">
                <div class="c6_cont_right">
                    <div class="c6_item">
                        <img src="../img/艺术课程/Star 16.png" alt="">
                        <p class="cn">多对「1」教育系统</p>
                    </div>
                    <div class="c6_item">
                        <img src="../img/艺术课程/Star 16.png" alt="">
                        <p class="cn">多重五维审核体系</p>
                    </div>
                    <div class="c6_item">
                        <img src="../img/艺术课程/Star 16.png" alt="">
                        <p class="cn">四级教学法</p>
                    </div>
                    <div class="c6_item">
                        <img src="../img/艺术课程/Star 16.png" alt="">
                        <p class="cn">招生官艺术规划</p>
                    </div>
                    <div class="c6_item">
                        <img src="../img/艺术课程/Star 16.png" alt="">
                        <p class="cn">海外高等院校教学模式</p>
                    </div>
                    <div class="c6_item">
                        <img src="../img/艺术课程/Star 16.png" alt="">
                        <p class="cn">VIP奖学金计划</p>
                    </div>

                </div>
            </div>
        </div>
        <div class="courses7">
            <div class="section_title">
                <p class="section_cn">优秀案例</p>
                <p class="section_en">SELECTED CASES</p>
            </div>
            <div class="c7_cont">
                <div class="swiper mySwiperC1">
                    <div class="swiper-wrapper">

                        <div class="swiper-slide" v-for="(item, index) in selectedData">
                            <div class="c7_item" v-for="(item2, index2) in item" @click="caseDetail(item2.id)">
                                <p class="c7_p1">RoSSo</p>
                                <img :src="'https://public.rossoarts.com/static/uploads/case/' + item2.portfolioShow"
                                    alt="">
                                <p class="c7_p2">{{ item2.name }}</p>
                                <p class="c7_p3">{{ item2.cname }}</p>
                                <p class="c7_p3">{{ item2.school | schoolSplit }}</p>
                            </div>

                        </div>


                    </div>
                    <div class="swiper-button-next"></div>
                    <div class="swiper-button-prev"></div>
                </div>
            </div>

        </div>
        <SectionInp></SectionInp>

        <!-- 最外层 div -->
    </div>
</template>

<script>
import "../assets/css/courses.css";
import { WOW } from 'wowjs'
import Swiper from 'swiper/bundle'
import axios from "axios";
import SectionInp from '@/components/SectionInp.vue'
import HeadImg from '@/components/HeadImg.vue'
import imgCourses from '@/img/艺术课程/Rectangle\ 616.jpg'
export default {
    components: {
        SectionInp,
        HeadImg
    },
    data() {
        return {
            selectedData: [],
            imgCourses,
            titleName: {
                cname: "艺术课程",
                ename: "ART COURSE"
            }
        }
    },
    created() {
        // this.oldWeb()
        this.getSelected()
    },
    // watch: {
    //     cases() {
    //         this.$nextTick(() => { // 在 dom 渲染完后，再执行动画
    //             var wow = new WOW({
    //                 live: false
    //             })
    //             wow.init()
    //         })
    //     }
    // },
    filters: {
        schoolSplit(val) {

            return val.split("/")[0]
        },
    },
    methods: {
        caseDetail(val) {
            this.$router.push(`/case/${val}.html`)
        },

        arrGroup(array, sublength) {
            let index = 0;
            let newArray = []
            while (index < array.length) {
                newArray.push(array.slice(index, index += sublength))
            }
            return newArray
        },
        getSelected() {
            axios.get("https://public.rossoarts.com/api/v1/getFirstCase?limit=24&page=1").then((data) => {
                // console.log(data.data);
                // console.log(this.arrGroup(data.data, 3));
                this.selectedData = this.arrGroup(data.data, 3)
                this.$nextTick(() => {
                    this.mySwiperInt()
                })
            })
        },
        c5animate(val) {
            var c5_hid = document.getElementsByClassName("c5_hid")
            var c5_show = document.getElementsByClassName("c5_show")
            var c5_show_img = document.getElementsByClassName("c5_show_img")
            var c5_line1 = document.getElementsByClassName("c5_line1")
            var c5_line2 = document.getElementsByClassName("c5_line2")
            c5_hid[val].style.display = "block"
            c5_show[val].style.borderRadius = "30px 30px 0 0"
            c5_show[val].style.borderBottom = "none"
            c5_hid[val].style.borderRadius = "  0 0 30px 30px"
            c5_show_img[val].src = require("../img/艺术课程/Group 296.png")
            if (val < 2) {

                c5_line1[0].style.animationPlayState = "paused"
            } else {
                c5_line2[0].style.animationPlayState = "paused"
            }

        },
        c5animateBack(val) {
            var c5_hid = document.getElementsByClassName("c5_hid")
            var c5_show = document.getElementsByClassName("c5_show")
            var c5_show_img = document.getElementsByClassName("c5_show_img")
            var c5_line1 = document.getElementsByClassName("c5_line1")
            var c5_line2 = document.getElementsByClassName("c5_line2")
            c5_hid[val].style.display = "none"
            c5_show[val].style.borderRadius = "100px"
            c5_show[val].style.borderBottom = "2px solid #000"
            c5_hid[val].style.borderRadius = "  30px 30px 0 0"
            c5_show_img[val].src = require("../img/艺术课程/Group 303.png")

            if (val < 2) {
                c5_line1[0].style.animationPlayState = ""
            } else {
                c5_line2[0].style.animationPlayState = ""
            }
        },
        oldWeb() {
            window.open("https://public.rossoarts.com/gdzpj.html", "_blank")
        },
        mySwiperInt() {
            var swiper2 = new Swiper(".mySwiperC1", {

                // pagination: {
                //     el: ".swiper-pagination",
                //     clickable: true,
                // },
                loop: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                observer: true,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
            });
        }
    },
    mounted() {
        var init = new WOW().init();


    }
}
</script>
<style src=""></style>